import _ from 'lodash';
import { REGEXP } from '@/constants/regexp';
import { SHORTCUTSCONFIG } from '@/constants/reportField.js';
import { getSaleEmployeeList, getSaleOrganizationTree } from '@/pages/agency/manage/operation-log/api';
import { enumMessages, getMessage } from '@/utils/MessageUtils';
import IndustrySelectFilter from '@/business-components/sale/IndustrySelectFilter';

const fetchSaleData = () => Promise.all([
  getSaleOrganizationTree(),
  getSaleEmployeeList({
    data: {
      field: 'USER_NAME',
    },
  }),
]);

let teamMap = {};
const getTeamTree = (teamTree: any) => {
  const cascadeTree: any = [];
  _.forEach(teamTree, (value) => {
    teamMap = { ...teamMap, [value.teamId]: value.name };
    if (value.children && value.children.length) {
      cascadeTree.push({
        desc: value.name,
        value: value.teamId,
        parent_id: value.parentId,
        options: getTeamTree(value.children),
      });
    } else {
      cascadeTree.push({
        desc: value.name,
        value: value.teamId,
        parent_id: value.parentId,
      });
    }
  });
  return cascadeTree;
};

// 所属团队
const convertTeamData = (res: any) => {
  const [organizationTree = {}] = res;
  const teamTree = _.get(organizationTree, 'teams');
  return getTeamTree(teamTree);
};

// 获取分发线索状态
const getPotentialStatusData = () => {
  const mode: any = 'select';
  const usePotentialStatusNew = false;
  return _.compact(_.map(enumMessages('MixedPotentialStatus'), (message) => {
    if (mode === 'block' && ((!usePotentialStatusNew && message.value === 'POTENTIAL_STATUS_NEW-0') || message.value === 'POTENTIAL_STATUS_NORMAL-100')) {
      return undefined;
    }
    if ((!mode || mode !== 'block') && message.value === 'POTENTIAL_STATUS_NORMAL-100') {
      return undefined;
    }
    return {
      value: message.value,
      label: message.message,
      description: getMessage(message.value, 'MixedPotentialStatus_PopOver'),
    };
  }));
};

export default {
  phoneSource: {
    name: 'phoneSource',
    title: '手机号来源',
    type: 'select',
    defaultValue: 1,
    config: {
      data: [
        {
          label: '原线索联系人电话',
          value: 1,
        },
        {
          label: '增补联系人电话',
          value: 2,
        },
      ],
    },
  },
  // 行业
  industry_id_list_lead: {
    name: 'industryIds',
    title: '行业',
    type: 'custom',
    component: IndustrySelectFilter,
    config: {
      search: true,
      multiple: true,
    },
  },
  leadImportTime: {
    name: 'leadImportTime',
    title: '线索导入时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择线索导入时间',
      optionalStartDate: '2019-01-01',
    },
    nameMap: {
      start_time: 'leadImportStartTime',
      end_time: 'leadImportEndTime',
    },
  },
  lastActionTime: {
    name: 'lastActionTime',
    title: '最后跟进时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择最后跟进时间',
      optionalStartDate: '2019-01-01',
    },
    nameMap: {
      start_time: 'lastActionStartTime',
      end_time: 'lastActionEndTime',
    },
  },
  leadLayerTypes: {
    name: 'leadLayerTypes',
    title: '线索分层',
    type: 'select',
    config: {
      multiple: true,
      placeholder: '请选择线索分层',
      data: [
        {
          label: 'LA',
          value: 'LEAD_LAYER_LA',
        },
        {
          label: 'SMB',
          value: 'LEAD_LAYER_SMB',
        },
        {
          label: '未识别',
          value: 'LEAD_LAYER_LA_UNRECOGNIZED',
        },
      ],
    },
  },
  teamIds: {
    name: 'teamIds',
    title: '所属团队',
    type: 'select-tree',
    config: {
      multiple: true,
      placeholder: '请选择所属团队',
      data: [],
      fetchData: fetchSaleData,
      convertData: convertTeamData,
    },
  },
  distributeStatuses: {
    name: 'distributeStatuses',
    title: '分发状态',
    type: 'select',
    config: {
      multiple: true,
      placeholder: '请选择分发状态',
      data: [
        {
          label: '未分发',
          value: 0,
        },
        {
          label: '已分发',
          value: 1,
        },
        {
          label: '分发中',
          value: 2,
        }],
    },
  },
  submitToDistributePool: {
    name: 'submitToDistributePool',
    title: '提交分发时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择提交分发时间',
      optionalStartDate: '2022-01-01',
    },
    nameMap: {
      start_time: 'submitToDistributePoolStartTime',
      end_time: 'submitToDistributePoolEndTime',
    },
  },
  distribute: {
    name: 'distribute',
    title: '分发时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择分发时间',
      optionalStartDate: '2022-01-01',
    },
    nameMap: {
      start_time: 'distributeStartTime',
      end_time: 'distributeEndTime',
    },
  },
  distributeLeadId: {
    name: 'distributeLeadId',
    title: '分发线索ID',
    type: 'search',
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
    config: {
      placeholder: '请输入分发线索ID',
    },
  },
  distributeAgencyIds: {
    name: 'distributeAgencyIds',
    title: '分发服务商',
    type: 'select',
    config: {
      multiple: true,
      placeholder: '请选择分发服务商',
    },
  },
  // 分发线索阶段/状态
  distributeStepStatuses: {
    name: 'stepStatuses',
    title: '分发线索阶段/状态',
    type: 'select-tree',
    config: {
      multiple: true,
    },
  },
  distributeLeadOrderCreated: {
    name: 'distributeLeadOrderCreated',
    title: '分发线索提单时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择分发线索提单时间',
      optionalStartDate: '2022-01-01',
    },
    nameMap: {
      start_time: 'distributeLeadOrderCreatedStartTime',
      end_time: 'distributeLeadOrderCreatedEndTime',
    },
  },
  orderPaymentConfirmed: {
    name: 'orderPaymentConfirmed',
    title: '分发线索到款审核通过时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择分发线索到款审核通过时间',
      optionalStartDate: '2022-01-01',
    },
    nameMap: {
      start_time: 'orderPaymentConfirmedStartTime',
      end_time: 'orderPaymentConfirmedEndTime',
    },
  },
  distributeLeadOrderingProductId: {
    name: 'distributeLeadOrderingProductId',
    title: '分发线索提单产品',
    type: 'select',
    config: {
      placeholder: '请选择分发线索提单产品',
    },
  },
};
